/*
 *
 * LanguageProvider actions
 *
 */

import { CHANGE_LOCALE, LOAD_LOCALE } from './constants';

export function changeLocale(languageLocale) {
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}

export function loadLocale(){
  return {
    type : LOAD_LOCALE
  }
}